import { useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * Wrapper for customer-facing public pages.
 *
 * While mounted it forces the document into light mode by calling
 * enterForcedLight() on ThemeContext — which makes the class-toggle
 * effect skip applying 'dark' regardless of the stored tenant preference.
 * On unmount it calls exitForcedLight() so the authenticated tenant UI
 * seamlessly resumes its own theme when the user navigates back.
 */
export default function ForceLightTheme({ children }) {
  const { enterForcedLight, exitForcedLight } = useTheme();

  useEffect(() => {
    enterForcedLight();
    return () => {
      exitForcedLight();
    };
  }, [enterForcedLight, exitForcedLight]);

  return children;
}
